export default "/_next/static/fonts/411b49703a3fd6f5e98108b6129fa050.eot";